module.exports = __webpack_public_path__ + "images/buroscanbrit_small268afd14ab62ef8d2936c36c69766ea1.png";